export default __webpack_public_path__ + "static/media/dark-app-preview.9db6fc94.png";